import { render, staticRenderFns } from "./technologyManagement.vue?vue&type=template&id=a32cff4e&scoped=true"
import script from "./technologyManagement.vue?vue&type=script&lang=js"
export * from "./technologyManagement.vue?vue&type=script&lang=js"
import style0 from "./technologyManagement.vue?vue&type=style&index=0&id=a32cff4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32cff4e",
  null
  
)

export default component.exports